import * as uuid from 'uuid';

/**
 * A randomly generated UUID to identify each page load (i.e. client application instance).
 *
 * This value allows the server to uniquely identify a particular instance of the client application. The
 * lifecycle and availability of this value to the server have some quirks worth stating explicitly:
 * 1. pageLoadID will survive logout/login events (it's not a session ID).
 * 2. pageLoadID will not survive a browser refresh.
 * 3. X-Page-Load-ID will only be present for XHR requests (fetch, jQuery, and GraphQL).
 */
export const pageLoadID = uuid.v4();

export function getClientHeaders(): {[key: string]: string} {
  return {
    'X-Page-Load-ID': pageLoadID,
    'X-Client-API-Version': window.clientAPIVersion,
    'X-Client-Release': window.REVISION,
  };
}

export function clientHeadersSetter(
  this: JQueryAjaxSettings,
  xhr: XMLHttpRequest,
  settings: JQueryAjaxSettings
): void {
  if (!this.crossDomain) {
    for (const [header, value] of Object.entries(getClientHeaders())) {
      xhr.setRequestHeader(header, value);
    }
  }
}
